import React from "react";
import { Drawer, Row, Col, Form, Input, Select, Button } from "antd";
const Option = Select.Option;

const recipe = [
  { id: Math.random(), value: 1, text: "Sim" },
  { id: Math.random(), value: 0, text: "Não" },
];

const DrawerFilter = (props) => {
  const { sCodigo } = props.filter;

  async function cleanFilters() {
    await props.handleReset();
    props.handleFilters();
  }

  return (
    <Drawer
      className="ant-drawer--custom"
      title="Filtrar CFOP"
      width={400}
      onClose={props.onClose}
      visible={props.visibleDrawer}
    >
      <Form layout="vertical" hideRequiredMark>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Código">
              <Input
                className="form-control"
                name="Codigo"
                value={sCodigo && sCodigo.substr(1)}
                onChange={props.handleChangeField}
                onPressEnter={props.handleFilters}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Considera Receita">
              <Select
                className="ant-select--custom"
                defaultValue={props.selectedConsider}
                value={props.selectedConsider}
                onChange={(e) =>
                  props.handleChangeField(e, "ConsiderarReceita")
                }
              >
                <Option value={null}>Selecione uma opção</Option>
                {recipe.map((item) => {
                  return (
                    <Option key={item.id} value={item.value}>
                      {item.text}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div className="ant-drawer__footer" style={{ width: "400px" }}>
        <Button className="mr-3" onClick={() => cleanFilters()}>
          Limpar
        </Button>

        <Button
          onClick={() => {
            props.handleFilters();
            props.onClose();
          }}
          type="primary"
        >
          Filtrar
        </Button>
      </div>
    </Drawer>
  );
};

export default DrawerFilter;
